export enum Domains {
  FLOWCODE = 'flowcode',
  FLOWPAGE = 'flowpage'
}

export interface FirebaseConfigType {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId: string
}
